import deepMerge from 'deepmerge';

import filingEntityHeader from './filing-entity-header';
import tableExpander from './table-expander';
import userList from './user-list';

export default deepMerge.all([userList, tableExpander, filingEntityHeader]);
